import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useCurrentUser } from '@/entities';
import { useAuthStore } from '@/shared/lib/store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Himoyalangan routelar uchun wrapper component.
 * Agar user login bo'lmagan bo'lsa, /login sahifasiga yo'naltiradi.
 * Keyin login bo'lganda, oldingi sahifaga qaytaradi.
 */
export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);
  const setUser = useAuthStore((state) => state.setUser);
  const logout = useAuthStore((state) => state.logout);
  const location = useLocation();

  // Keep the session user in sync with `/auth/user-me` (user_type, partner_id, ...).
  const currentUserQuery = useCurrentUser({ enabled: isAuthenticated });

  useEffect(() => {
    if (!isAuthenticated) return;

    if (currentUserQuery.data?.success && currentUserQuery.data.result) {
      setUser(currentUserQuery.data.result);
      return;
    }

    // Only drop the session when we have no user yet and user-me failed.
    if (!user && (currentUserQuery.isError || (currentUserQuery.data && !currentUserQuery.data.success))) {
      logout();
    }
  }, [isAuthenticated, user, currentUserQuery.data, currentUserQuery.isError, setUser, logout]);

  if (!isAuthenticated) {
    // Login sahifasiga yo'naltiramiz, lekin hozirgi locationni saqlaymiz
    // Shunda login bo'lgandan keyin qaytib kelishi mumkin
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  if (isAuthenticated && !user && currentUserQuery.isFetching) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 240 }}>
        <Spin size='large' />
      </div>
    );
  }

  return <>{children}</>;
};
